/* Satva Farm recipes — shared helpers (votes, toast, money) */
(function () {
  var cfg = window.SatvaRecipes = window.SatvaRecipes || {};
  var KEY = 'satva_recipe_votes';

  function store(get, val) {
    try {
      if (get) return JSON.parse(localStorage.getItem(KEY) || '[]');
      localStorage.setItem(KEY, JSON.stringify(val));
    } catch (e) { return []; }
  }
  cfg.voted = function (h) { return (store(true) || []).indexOf(h) > -1; };

  cfg.money = function (paise) {
    var r = Math.round(paise) / 100;
    return '₹' + r.toLocaleString('en-IN', { minimumFractionDigits: r % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };

  var toastEl;
  cfg.toast = function (html, ms) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'sr-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = html;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, ms || 3500);
  };

  function paint(btn, voted, count) {
    btn.setAttribute('aria-pressed', voted ? 'true' : 'false');
    btn.setAttribute('aria-label', voted ? 'You voted for this recipe' : 'Vote for this recipe');
    var c = btn.querySelector('[data-count]');
    if (c && count != null) c.textContent = count;
  }

  cfg.initVotes = function (root) {
    var btns = (root || document).querySelectorAll('[data-vote]');
    if (!cfg.voteUrl) { btns.forEach(function (b) { b.hidden = true; }); return; }
    btns.forEach(function (btn) {
      var h = btn.getAttribute('data-vote');
      paint(btn, cfg.voted(h));
      btn.hidden = false;
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (cfg.voted(h)) { cfg.toast('Thanks — you have already voted for this recipe.'); return; }
        var c = btn.querySelector('[data-count]');
        var n = (parseInt(c && c.textContent, 10) || 0) + 1;
        paint(btn, true, n);
        var list = store(true) || []; list.push(h); store(false, list);
        var card = btn.closest('[data-votes]');
        if (card) card.setAttribute('data-votes', n);
        fetch(cfg.voteUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ handle: h }) })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) { if (d && typeof d.votes === 'number') { paint(btn, true, d.votes); if (card) card.setAttribute('data-votes', d.votes); } })
          .catch(function () {});
        cfg.toast('Thanks for voting! Popular recipes rise to the top.');
      });
    });
  };
})();
